import { gql } from '@apollo/client'

export const LOGIN_USER = gql`
  mutation LoginUser($input: LoginInput!) {
    loginUser(input: $input) {
      token
      user {
        customerId
        role
        userName
      }
    }
  }
`

export const DELETE_DEVICE = gql`
  mutation DeleteDevice($deviceId: String!) {
    deleteDevice(deviceId: $deviceId)
  }
`

export const UPDATE_DEVICE = gql`
  mutation UpdateDevice($input: UpdateDeviceInput!) {
    updateDevice(input: $input) {
      deviceId
      name
      status
      slideshowVersions {
        slideshowId
        level
      }
    }
  }
`

export const SCHEDULE_SLIDESHOW = gql`
  mutation ScheduleSlideshow($input: NewScheduledSlideshowInput) {
    scheduleSlideshow(input: $input) {
      id
      name
    }
  }
`

export const UPDATE_SCHEDULED_SLIDESHOW = gql`
  mutation UpdateScheduledSlideshow($input: UpdateScheduledSlideshowInput!) {
    updateScheduledSlideshow(input: $input) {
      id
      name
      dateTime
      deviceIds
      processed
    }
  }
`

export const UPDATE_MEDIA_ITEM = gql`
  mutation UpdateMediaItem($input: UpdateMediaItemInput!) {
    updateMediaItem(input: $input)
  }
`
export const UPDATE_SLIDE = gql`
  mutation UpdateSlide($input: SlideInput!) {
    updateSlide(input: $input) {
      slideId
      previewURL
      tags
    }
  }
`

export const CREATE_MEDIA_ITEM = gql`
  mutation CreateMediaItem($input: NewMediaItemInput!) {
    createMediaItem(input: $input) {
      mediaItemId
      type
      width
      height
    }
  }
`

export const CREATE_SLIDE = gql`
  mutation CreateSlide($input: NewSlideInput!) {
    createSlide(input: $input) {
      slideId
      type
      layout
    }
  }
`

export const DELETE_MEDIA_ITEM = gql`
  mutation DeleteMediaItem($mediaItemId: String!, $force: Boolean) {
    deleteMediaItem(mediaItemId: $mediaItemId, force: $force)
  }
`

export const DELETE_SLIDE = gql`
  mutation DeleteSlide($slideId: String!) {
    deleteSlide(slideId: $slideId)
  }
`

export const CREATE_SLIDESHOW = gql`
  mutation CreateSlideshow($input: NewSlideshowInput!) {
    createSlideshow(input: $input) {
      slideshowId
    }
  }
`

export const UPDATE_SLIDESHOW = gql`
  mutation UpdateSlideshow($input: SlideshowInput!) {
    updateSlideshow(input: $input) {
      slideshowId
      name
      locationIds
    }
  }
`

export const DELETE_SLIDESHOW = gql`
  mutation DeleteSlideshow($slideshowId: String!) {
    deleteSlideshow(slideshowId: $slideshowId)
  }
`

export const DELETE_SCHEDULE_SLIDESHOW_BY_ID = gql`
  mutation DeleteScheduledSlideshowById($id: String!) {
    deleteScheduledSlideshowById(id: $id)
  }
`

export const SET_DEVICE_COMMANDS = gql`
  mutation SetDeviceCommands($deviceId: String!, $commands: [String!]!) {
    setDeviceCommands(deviceId: $deviceId, commands: $commands)
  }
`

export const DETACH_DEVICE = gql`
  mutation DetachDevice($deviceId: String!) {
    detachDevice(deviceId: $deviceId)
  }
`

export const CREATE_LOCATION = gql`
  mutation CreateLocation($input: NewLocationInput!) {
    createLocation(input: $input) {
      locationId
      name
    }
  }
`

export const CREATE_USER = gql`
  mutation CreateUser($input: NewUserInput!) {
    createUser(input: $input) {
      userName
      role
      customerId
    }
  }
`

export const UPDATE_USER = gql`
  mutation UpdateUser($input: UpdateUserInput!) {
    updateUser(input: $input) {
      userName
      role
      customerId
      customer {
        customerId
        name
      }
      locations {
        locationId
        name
      }
    }
  }
`

export const UPDATE_DEVICE_PROPERTIES = gql`
  mutation UpdateDeviceProperties($input: UpdateDevicePropertiesInput!) {
    updateDeviceProperties(input: $input) {
      deviceId
      deviceProperties
    }
  }
`
